import { Tabs, Theme, useStyles, VFlow } from 'bold-ui'
import { PageContainer } from 'components/layout/PageContainer'
import { TabLink } from 'components/route'
import React from 'react'
import { useRouteMatch } from 'react-router'

import { AtendimentoCidadaoHeader } from '../detail/AtendimentoCidadaoHeader'

export interface EscutaInicialHeaderProps {
  cidadaoId: ID
}

export function EscutaInicialHeader(props: EscutaInicialHeaderProps) {
  const { cidadaoId } = props
  const match = useRouteMatch()
  const { classes } = useStyles(createStyles)

  return (
    <div className={classes.container}>
      <PageContainer>
        <VFlow>
          <AtendimentoCidadaoHeader cidadaoId={cidadaoId} />

          <Tabs>
            <TabLink to={`${match.url}/folha-rosto`}>Folha de rosto</TabLink>
            <TabLink exact to={`${match.url}`}>
              Escuta inicial
            </TabLink>
          </Tabs>
        </VFlow>
      </PageContainer>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  container: {
    marginTop: '2rem',
    borderBottom: `1px solid ${theme.pallete.divider}`,
  },
})
